import React from 'react';
export var Emoji = function (_a) {
    var children = _a.children;
    return (React.createElement("span", { className: 'inline-text-emoji', "data-testid": 'inline-text-emoji' }, children));
};
